import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '../views/Home.vue'
import FullView from '../views/FullView.vue'
import Detail from '../views/detail.vue'
import LineDetail from '../views/lineDetail.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Home',
		component: HomePage,
		meta: { 
			keepAlive: true
		}
	},{
		path: '/view',
		name: 'View',
		component: FullView,
		meta: { 
			keepAlive: false
		}
	},{
		path: '/detail',
		name: 'Detail',
		component: Detail,
		meta: { 
			keepAlive: false
		}
	},{
		path: '/lineDetail',
		name: 'LineDetail',
		component: LineDetail,
		meta: { 
			keepAlive: false
		}
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
});

export default router
